import React from 'react';

import PropTypes from 'prop-types';

import { ItemContainer, Title } from './styles';

export const DocsListItem = (props) => {
    return (
        <ItemContainer blackText={props.blackText}>
            {props.title && <Title>{props.title}</Title>}
            {props.children}
        </ItemContainer>
    );
};

DocsListItem.propTypes = {
    title: PropTypes.string,
    blackText: PropTypes.bool,
};
